import { SettingsEthernet } from '@material-ui/icons';
import React, { useState, useCallback } from 'react';

export function TestServerScript() {
    const [request, setRequest] = useState('{\n  "value": 1\n}\n');
    const [lua, setLua] = useState(`local json = require("json")
return function(input)
  local request = json.decode(input)
  request.value = request.value + 1
  return json.encode(request)
end
`);
    const [response, setResponse] = useState('');
    const [error, setError] = useState(null);
    const [sending, setSending] = useState(false);
    const send = useCallback(async () => {
        setSending(true);
        setError(null);
        setResponse('');
        const response = await fetch('https://tdarcade.wildsky.dev/script', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                request, lua,
            }),
        });
        if (!response.ok) {
            setSending(false);
            setError({ message: `Request has failed with: ${response.statusText}, ${await response.text()}` });
            return;
        }
        const result = await response.json();
        if (result.error) {
            setSending(false);
            setError(result.error);
            return;
        }
        setSending(false);
        setResponse(result.response);
    }, [request, lua]);
    return <div style={{ display: 'flex', flexDirection: 'column', padding: '18px' }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div>
                <h3>Request</h3>
                <textarea value={request} onChange={(e) => setRequest(e.target.value)} rows={20} cols={80} />
            </div>
            <div>
                <h3>Lua</h3>
                <textarea value={lua} onChange={(e) => setLua(e.target.value)} rows={20} cols={150} />
            </div>
        </div>
        <div>
            <button onClick={send} disabled={sending}>Send</button>
            {
                error &&
                <div>
                    <pre>{error.message}</pre>
                    <pre>{error.stackTrace}</pre>
                </div>
            }
            {
                response &&
                <pre>
                    {response}
                </pre>
            }
        </div>
    </div>;
}
